import type { CommandContext } from '../model/analysis-commands';
import { createWorkspace, type WorkspaceDocument } from '../model/workspace-document';
import { applyWorkspaceCommand, type WorkspaceCommand } from '../model/workspace-reducer';

export const workspaceIdFor = (modelId: string): string => `ws.${modelId}`;

/** Analisis inicial por modelo demo, construido con los mismos comandos que usa la UI. */
const STARTERS: Readonly<Record<string, readonly WorkspaceCommand[]>> = {
  'demo.retail': [
    {
      type: 'add-card',
      visualization: 'kpi',
      fieldIds: ['total_sales', 'order_count', 'avg_ticket'],
    },
    { type: 'resize-card', cardId: 'card-1', width: 4 },
    { type: 'add-card', visualization: 'line', fieldIds: ['dim.order_date', 'total_sales'] },
    { type: 'resize-card', cardId: 'card-2', width: 8 },
    { type: 'add-card', visualization: 'column', fieldIds: ['dim.category', 'total_sales'] },
    {
      type: 'add-card',
      visualization: 'table',
      fieldIds: ['dim.region', 'dim.segment', 'total_sales', 'order_count'],
    },
  ],
  'demo.support': [
    { type: 'add-card', visualization: 'column', fieldIds: ['dim.team', 'ticket_count'] },
    {
      type: 'add-card',
      visualization: 'table',
      fieldIds: ['dim.priority', 'ticket_count', 'avg_resolution'],
    },
  ],
};

/**
 * Crea el workspace inicial de un modelo. Si el modelo no tiene un analisis predefinido
 * (o algun comando no aplica), arranca con una tarjeta vacia lista para configurar.
 */
export function createStarterWorkspace(
  modelId: string,
  modelName: string,
  context: CommandContext,
): WorkspaceDocument {
  let document = createWorkspace({
    id: workspaceIdFor(modelId),
    name: `Analisis de ${modelName}`,
    semanticModelId: modelId,
  });
  const commands = STARTERS[modelId] ?? [{ type: 'add-card' }];
  for (const command of commands) {
    const outcome = applyWorkspaceCommand(document, command, context);
    if (outcome.rejection === null) document = outcome.document;
  }
  if (document.cards.length === 0) {
    const outcome = applyWorkspaceCommand(document, { type: 'add-card' }, context);
    document = outcome.document;
  }
  return document;
}
